/**
 * Signup Route
 *
 * Alias for the registration route to improve discoverability.
 * Delegates UI rendering to RegisterPage from FSD pages layer.
 */

import { createFileRoute } from '@tanstack/react-router';
import { RegisterPage } from '@pages/register';

export const Route = createFileRoute('/$locale/signup')({
  component: SignupRoute,
});

function SignupRoute() {
  const { locale } = Route.useParams();
  return <RegisterPage locale={locale} />;
}
